import {AUTH_INIT_STATE, SET_IS_AUTHENTICATED} from "./types";

export const authReducer = (state = AUTH_INIT_STATE, action) => {
    switch (action.type) {
        case SET_IS_AUTHENTICATED:
            return {...state, isAuthenticated: action.payload};
        default:
            return state
    }
}
